
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getSingleUserOrganization",
      resolverType: "query",
      routePath: "/getSingleUserOrganization",
      httpMethod: "POST",
    });
  